import { Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import SignInPage from "./pages/SignInPage";
import ForgotPasswordPage from "./pages/ForgotPassword";
import SetPasswordPage from "./pages/SetPasswordPage";
import SignUpPage from "./pages/SignUpPage";
import HowItWorks from "./pages/HowItWorks";
import PricingPage from "./pages/PricingPage";
import PricingPageBusinesses from "./pages/PricingPageBusinesses";
import PricingPageCouples from "./pages/PricingPageCouples";
import SolutionsPage from "./pages/SolutionsPage";
import Terms from "./pages/Terms";
import CheckVenue from "./pages/CheckVenue";
import RequestVenue from "./pages/RequestVenue";
import GiftPage from "./pages/Gifting";
import GiftSuccessPage from "./pages/gift/GiftSuccessPage";
import GiftCancelPage from "./pages/gift/GiftCancelPage";
import GiftRedeemPage from "./pages/gift/GiftRedeemPage";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/signin" element={<SignInPage />} />
    <Route path="/forgot_password" element={<ForgotPasswordPage />} />
    <Route path="/set_password" element={<SetPasswordPage />} />
    <Route path="/signup" element={<SignUpPage />} />
    <Route path="/how_it_works" element={<HowItWorks />} />
    <Route path="/pricing" element={<PricingPage />} />
    <Route path="/pricing/businesses" element={<PricingPageBusinesses />} />
    <Route path="/pricing/couples" element={<PricingPageCouples />} />
    <Route path="/solutions" element={<SolutionsPage />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/check-venue" element={<CheckVenue />} />
    <Route path ="/request-venue" element={<RequestVenue />} />
    <Route path="/gifting" element={<GiftPage />} />
    <Route path="/gift_success" element={<GiftSuccessPage />} />
    <Route path="/gift_cancelled" element={<GiftCancelPage />} />
    <Route path="/redeem" element={<GiftRedeemPage />} />
  </Routes>
);

export default AppRoutes;
